<template>
  <div
    class="table-cell text-nowrap border-b-2 bg-lightTertiaryColor py-[0.3rem] pl-[0.3rem] pr-sm text-start text-darkPrimaryTextColor dark:bg-transparent"
    :class="{
      'w-full': props.shouldFillColumn,
      'md:w-[1%]': !props.shouldFillColumn,
      'cursor-pointer': props.isSortable,
    }"
    @click="props.isSortable && toggleSortingDirection({ sorting, fieldName: props.fieldName })"
  >
    <slot name="content">
      <div class="flex items-center justify-between gap-4">
        <p v-if="props.text !== ''">
          {{ text }}
        </p>
        <div class="flex">
          <slot></slot>
        </div>
      </div>
    </slot>
  </div>
</template>
<script setup lang="ts">
import { toggleSortingDirection } from "../../service.genericTableQuery";
import { GenericTableSortingItems } from "../../type.genericTableQuery";

const props = defineProps<{
  text: string;
  shouldFillColumn: boolean;
  fieldName: string;
  isSortable: boolean;
}>();
const sorting = defineModel<GenericTableSortingItems>("sorting", { required: true });
</script>
